import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ButtonLoader from 'components/mui/ButtonLoader';

interface Props {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  loading?: boolean;
  description?: string;
  confirmLabel?: string;
}

export default function DeleteConfirmationDialog(props: Props) {
  const { open, onClose, onDelete, description, confirmLabel = 'Delete', loading = false } = props;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent sx={{ pt: { xs: '20px', md: 4 }, px: { xs: 3, md: 4 }, pb: { xs: 3, md: 4 } }}>
        <Typography variant="h3" fontWeight="bold">
          Are you sure?
        </Typography>
        {description ? (
          <Typography mt={1} variant="body2" color="secondary.low" maxWidth="416px">
            {description}
          </Typography>
        ) : null}
        <Stack mt={4} direction="row" alignItems="center" justifyContent="flex-end" gap="10px">
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={onDelete} disabled={loading}>
            <ButtonLoader label={confirmLabel} loading={loading} />
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
